.brandButton {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  padding: 0;
  font-weight: bold;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: 0.088px;
  color: #FFFFFF;
  border-radius: 30px;
  font-weight: 700;
  text-transform: lowercase;

  img {
    width: 24px;
  }

  p::first-letter {
    text-transform: capitalize;
  }

  @at-root html[lang="ru"] & {
    font-size: 18px;
  }

  @at-root html[lang="de"] & {
    font-size: 18px;
  }

  @at-root html[lang="fr"] & {
    font-size: 19px;
  }

  &Content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    gap: 8px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--ed-brand, #AE66F6);
      border-radius: 30px;
      z-index: -1;
      box-shadow: 0px 10px 20px rgb(0 0 0 / 30%);
    }
  }

  &[disabled] {
    opacity: 0.5;
  }

  &__animate::before,
  &__animate::after {
    content: "";
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
    display: block;
    height: 100%;
    width: 100%;
    background: var(--ed-brand, #AE66F6);
    border-radius: 30px;
    opacity: 0.4;
  }

  &__animate::before {
    animation: pulse1 0.8s * 1.5 cubic-bezier(0.25, 0.46, 0.45, 0.94)
      infinite both;
  }

  &__animate::after {
    animation: pulse2 0.8s * 1.5 0.1s
      cubic-bezier(0.25, 0.46, 0.45, 0.94) infinite both;
  }

  @keyframes pulse1 {
    0% {
      opacity: 0.8;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.07, 1.3);
    }
  }

  @keyframes pulse2 {
    0% {
      opacity: 0.8;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1.035, 1.2);
    }
  }
}